import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydLabel from '../../../../../../../../commonDesign/SydLabel'
import SydSelect from '../../../../../../../../commonDesign/SydSelect'
import SydInput from '../../../../../../../../commonDesign/SydInput'

const sortOptions = [
  { label: 'Descending', value: 'descending' },
  { label: 'Ascending', value: 'ascending' },
  { label: 'None', value: 'none' }
]

const orientOptions = [
  { label: 'Vertical', value: 'vertical' },
  { label: 'Horizontal', value: 'horizontal' }
]

const funnelAlignOptions = [
  { label: 'Center', value: 'center' },
  { label: 'Left', value: 'left' },
  { label: 'Right', value: 'right' }
]

function FunnelChartEditor ({ config, columns, onChange }) {
  const columnOptions = useMemo(() => {
    return [
      { label: 'Select a column...', value: '' },
      ...columns.map(col => ({ label: col.name, value: col.name }))
    ]
  }, [columns])

  const handleChange = useCallback((field, value) => {
    onChange({ [field]: value })
  }, [onChange])

  const handleTooltipChange = useCallback((field, value) => {
    onChange({ tooltip: { ...(config.tooltip || {}), [field]: value || null } })
  }, [onChange, config.tooltip])

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={4}>
        <SydLabel required label='Name Column'>
          <SydSelect
            minWidth='0'
            options={columnOptions}
            value={config.nameAccessor || ''}
            onChange={(e) => handleChange('nameAccessor', e.target.value || null)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={4}>
        <SydLabel required label='Value Column'>
          <SydSelect
            minWidth='0'
            options={columnOptions}
            value={config.valueAccessor || ''}
            onChange={(e) => handleChange('valueAccessor', e.target.value || null)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={4}>
        <SydLabel label='Sort'>
          <SydSelect
            minWidth='0'
            options={sortOptions}
            value={config.sort || 'descending'}
            onChange={(e) => handleChange('sort', e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Orientation'>
          <SydSelect
            minWidth='0'
            options={orientOptions}
            value={config.orient || 'vertical'}
            onChange={(e) => handleChange('orient', e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Alignment'>
          <SydSelect
            minWidth='0'
            options={funnelAlignOptions}
            value={config.funnelAlign || 'center'}
            onChange={(e) => handleChange('funnelAlign', e.target.value)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Gap'>
          <SydInput
            minWidth='0'
            type='number'
            value={config.gap ?? 0}
            onChange={(e) => handleChange('gap', Number(e.target.value) || 0)}
          />
        </SydLabel>
      </Grid>
      <Grid item xs={6} md={3}>
        <SydLabel label='Tooltip Value Format'>
          <SydInput
            minWidth='0'
            value={config.tooltip?.valueFormat || ''}
            onChange={(e) => handleTooltipChange('valueFormat', e.target.value)}
            placeholder='number'
          />
        </SydLabel>
      </Grid>
    </Grid>
  )
}

FunnelChartEditor.propTypes = {
  config: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default FunnelChartEditor
